/* eslint-disable max-len */
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

const useStyles = makeStyles(() => ({
  root: {
    width: '1em',
    height: '1em',
  },
}));

export default function EsLang({ className }) {
  const classes = useStyles();
  return (
    <SvgIcon viewBox='0 0 21 14' className={classnames(classes.root, className)}>
      <g id='esp' transform='translate(-1157 -178)'>
        <g id='spain' transform='translate(1157 178)' stroke='#808f94' strokeWidth='1'>
          <rect width='21' height='14' rx='2' fill='#c60b1e' stroke='none' />
          <rect y='3.5' width='21' height='7' fill='#ffc400' stroke='none' />
          <rect x='0.5' y='0.5' width='20' height='13' rx='1.5' fill='none' />
        </g>
      </g>
    </SvgIcon>
  );
}
